import React, { useState } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import {
  plotHookTable,
  burroughTable,
  enemyTypeTable,
  enemyMotivationTable,
  enemyArmorTable,
  enemyHPTable,
  enemyAttackTable,
  enemyMoraleTable,
  enemySpecialTable,
  quirksTable,
  physicalDistinctionsTable,
  obsessionsTable,
  stylesTable,
  dayJobsTable,
  dayJobsItemsTable,
  firstNamesTable,
  lastNameTable,
  animalFormsTable,
  oddLootTable,
  randomCityEncounterTable,
  weatherTable,
} from "../../tables/tables-utility.js";
import EpisodeBackground from "../../images/backgrounds/tv.jpg";
import ComicButton from "../Buttons/ComicButton.jsx";
import "./SewerScumEpGen.css";
import "../../styles/print.css";

function SewerScumEpGen() {
  //Used to generate a new character without refreshing the page
  const [throwaway, setThrowaway] = useState([0]);
  // Misc episode tables
  const plotHookValue = Math.floor(Math.random() * plotHookTable.length);
  const plotHook = plotHookTable[plotHookValue];
  const burroughValue = Math.floor(Math.random() * burroughTable.length);
  const burrough = burroughTable[burroughValue];
  const oddLootValue1 = Math.floor(Math.random() * oddLootTable.length);
  const oddLoot1 = oddLootTable[oddLootValue1];
  const oddLootValue2 = Math.floor(Math.random() * oddLootTable.length);
  const oddLoot2 = oddLootTable[oddLootValue2];
  const randomCityEncounterValue = Math.floor(
    Math.random() * randomCityEncounterTable.length
  );
  const randomCityEncounter =
    randomCityEncounterTable[randomCityEncounterValue];
  const weatherValue = Math.floor(Math.random() * weatherTable.length);
  const weather = weatherTable[weatherValue];

  // Enemy tables
  const enemyTypeValue = Math.floor(Math.random() * enemyTypeTable.length);
  const enemyType = enemyTypeTable[enemyTypeValue];
  const enemyMotivationValue = Math.floor(
    Math.random() * enemyMotivationTable.length
  );
  const enemyMotivation = enemyMotivationTable[enemyMotivationValue];
  const enemyArmorValue = Math.floor(Math.random() * enemyArmorTable.length);
  const enemyArmor = enemyArmorTable[enemyArmorValue];
  const enemyHPValue = Math.floor(Math.random() * enemyHPTable.length);
  const enemyHP = enemyHPTable[enemyHPValue];
  const enemyGroupSize = 6 - enemyHPValue;
  const enemyAttackValue = Math.floor(Math.random() * enemyAttackTable.length);
  const enemyAttack = enemyAttackTable[enemyAttackValue];
  const enemyMoraleValue = Math.floor(Math.random() * enemyMoraleTable.length);
  const enemyMorale = enemyMoraleTable[enemyMoraleValue];
  const enemySpecialValue = Math.floor(
    Math.random() * enemySpecialTable.length
  );
  const enemySpecial = enemySpecialTable[enemySpecialValue];
  const animalFormsValue = Math.floor(Math.random() * animalFormsTable.length);
  const animalForms = animalFormsTable[animalFormsValue];

  // NPC tables
  const quirksValue = Math.floor(Math.random() * quirksTable.length);
  const physicalDistinctionsValue = Math.floor(
    Math.random() * physicalDistinctionsTable.length
  );
  const obsessionsValue = Math.floor(Math.random() * obsessionsTable.length);
  const stylesValue = Math.floor(Math.random() * stylesTable.length);
  const dayJobsValue = Math.floor(Math.random() * dayJobsTable.length);
  const firstNamesValue = Math.floor(Math.random() * firstNamesTable.length);
  const lastNameValue = Math.floor(Math.random() * lastNameTable.length);
  const quirks = quirksTable[quirksValue];
  const physicalDistinctions =
    physicalDistinctionsTable[physicalDistinctionsValue];
  const obsessions = obsessionsTable[obsessionsValue];
  const styles = stylesTable[stylesValue].replace(/\s*\[.*$/, "");
  const dayJobs = dayJobsTable[dayJobsValue].replace(/\s*\[.*$/, "");
  const dayJobsItems = dayJobsItemsTable[dayJobsValue];
  const firstNames = firstNamesTable[firstNamesValue];
  const lastName = lastNameTable[lastNameValue];

  const PrintDiv = () => {
    window.print();
  };

  const NewEp = () => {
    setThrowaway(Number(throwaway) + 1);
    console.log(throwaway);
  };

  return (
    <div className="sewer-scum-ep-gen-container">
      <div className="no-print">
        <BrowserView>
          <ComicButton text="Save/Print" onClick={PrintDiv} />
          <ComicButton text="Where to next?" onClick={NewEp} />
        </BrowserView>
        <MobileView>
          <ComicButton
            text="Save/Print"
            onClick={PrintDiv}
            className="mobile"
          />
          <ComicButton
            text="Where to next?"
            onClick={NewEp}
            className="mobile"
          />
        </MobileView>
      </div>
      <div className="container" id="print-content">
        <img
          src={EpisodeBackground}
          className="ep-background"
          alt="tv-set-background"
        ></img>

        <div className="plot-hook-text episode-text">
          <strong>Plot Hook:</strong> {plotHook}
        </div>
        <div className="starting-location episode-text">
          <strong>Starting Location:</strong> {burrough}
        </div>
        <div className="weather episode-text">
          <strong>Weather:</strong> {weather}
        </div>
        <div className="enemy-and-npc-container">
          <div className="enemy-container">
            <div className="enemy-label episode-text">
              <strong>Main Adversary</strong>
            </div>
            <div className="enemy-type episode-text">
              <strong>- Type:</strong> {enemyType}{" "}
              <span>
                {enemyType === "Mutants" && (
                  <>
                    {" ["}
                    {animalForms}
                    {"]"}
                  </>
                )}
              </span>{" "}
              x{enemyGroupSize}
            </div>
            <div className="enemy-motivation episode-text">
              <strong>- Motivation:</strong> {enemyMotivation}
            </div>
            <div className="enemy-hp episode-text">
              <strong>- HP:</strong> {enemyHP}
            </div>
            <div className="enemy-armor episode-text">
              <strong>- Armor:</strong> {enemyArmor}
            </div>
            <div className="enemy-attack episode-text">
              <strong>- Attack:</strong> {enemyAttack}{" "}
              {["Mutants", "Ninjas", "Aliens"].includes(enemyType) && (
                <>{" [Melee]"}</>
              )}
              {["Robots", "Government Agents", "Mobsters"].includes(
                enemyType
              ) && <>{" [Ranged]"}</>}
            </div>
            <div className="enemy-morale episode-text">
              <strong>- Morale:</strong> {enemyMorale}
            </div>
            <div className="enemy-special episode-text">
              <strong>- Special:</strong> {enemySpecial}
            </div>
          </div>
          <div className="npc-container">
            <div className="npc-label episode-text">
              <strong>Unique NPC</strong>
            </div>
            <div className="npc-name episode-text">
              <strong>- Name:</strong>{" "}
              <span>{firstNames + " " + lastName}</span>
            </div>
            <div className="npc-job episode-text">
              <strong>- Day Job:</strong> {dayJobs}
            </div>
            <div className="npc-carrying episode-text">
              <strong>- Carrying:</strong> {dayJobsItems}
            </div>
            <div className="npc-style episode-text">
              <strong>- Style:</strong> {styles}
            </div>
            <div className="npc-distinction episode-text">
              <strong>- Distinction:</strong> {physicalDistinctions}
            </div>
            <div className="npc-quirk episode-text">
              <strong>- Quirk:</strong> {quirks}
            </div>
            <div className="npc-obsession episode-text">
              <strong>- Obsession:</strong> {obsessions}
            </div>
          </div>
        </div>
        <div className="random-city-encounter episode-text">
          <strong>Random City Encounter:</strong> {randomCityEncounter}
        </div>
        <div className="odd-loot-1 episode-text">
          <strong>Odd Loot:</strong> {oddLoot1}
        </div>
        <div className="odd-loot-2 episode-text">
          <strong>Odd Loot:</strong> {oddLoot2}
        </div>
      </div>
    </div>
  );
}

export default SewerScumEpGen;
